import { Fragment, Component } from 'react';

// eslint-disable-next-line import/no-extraneous-dependencies
import { BuildStatus } from 'src/components/types';

import { BuildStatusesMap } from '../../types';
import Trigger from '../build-status/trigger';
import { BuildSummary } from '../build-summary';
import { BuildStatusModalDialog } from '../modal-dialog';

export type LazyBuildStatusProps = {
  buildCounts: BuildStatusesMap;
  loadBuilds: () => Promise<BuildStatus[]>;
  showIcon?: boolean;
  routerPush?: (pathname: string) => void;
  ignoreStoppedBuildStatus?: boolean;
};

type State = {
  isDialogOpen: boolean;
  isLoadingBuilds: boolean;
  builds: BuildStatus[];
  lastCounts: BuildStatusesMap;
};

const totalBuilds = (buildCounts: BuildStatusesMap) => {
  const { FAILED, INPROGRESS, STOPPED, SUCCESSFUL } = buildCounts;
  return FAILED + INPROGRESS + STOPPED + SUCCESSFUL;
};

const isBuildCountsEqual = (a: BuildStatusesMap, b: BuildStatusesMap) =>
  // @ts-ignore TODO: fix noImplicitAny error here
  Object.keys(a).every(key => a[key] === b[key]);

class LazyBuildStatus extends Component<LazyBuildStatusProps, State> {
  static getDerivedStateFromProps(props: LazyBuildStatusProps, state: State) {
    // If we got new build counts, reset the list of full builds.
    if (!isBuildCountsEqual(props.buildCounts, state.lastCounts)) {
      return {
        ...state,
        builds: [],
        lastCounts: props.buildCounts,
      };
    }
    return null;
  }

  state = {
    isDialogOpen: false,
    isLoadingBuilds: false,
    builds: [],
    lastCounts: this.props.buildCounts,
  };

  onTrigger = () => {
    if (this.state.builds.length) {
      this.setState({ isDialogOpen: true });
      return;
    }

    this.setState({ isLoadingBuilds: true });
    this.props
      .loadBuilds()
      .then(builds => {
        // Check to see if we have a real array of builds.
        // Maybe the consumer caught an error and forgot to return
        // anything to us
        if (Array.isArray(builds) && builds.length) {
          this.setState({
            builds,
            isLoadingBuilds: false,
            isDialogOpen: true,
          });
        } else {
          this.setState({ isLoadingBuilds: false });
        }
      })
      .catch(() => {
        this.setState({ isLoadingBuilds: false });
      });
  };

  onCloseDialog = () => {
    this.setState({ isDialogOpen: false });
  };

  render() {
    const { isDialogOpen, isLoadingBuilds, builds } = this.state;
    const { buildCounts, showIcon, routerPush, ignoreStoppedBuildStatus } =
      this.props;
    const buildCount = totalBuilds(buildCounts);

    if (!buildCount) {
      return null;
    }

    return (
      <Fragment>
        <Trigger
          buildCounts={buildCounts}
          onTrigger={this.onTrigger}
          isLoading={isLoadingBuilds}
          showIcon={showIcon}
          ignoreStoppedBuildStatus={ignoreStoppedBuildStatus}
        />
        {isDialogOpen && (
          <BuildStatusModalDialog onClose={this.onCloseDialog}>
            <BuildSummary builds={builds} routerPush={routerPush} />
          </BuildStatusModalDialog>
        )}
      </Fragment>
    );
  }
}

// eslint-disable-next-line import/no-default-export
export default LazyBuildStatus;
